import React from 'react';
import { kitContents } from '../data/kitContents';
import { Reveal } from './Reveal';
export function KitContentsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-93" data-mp="209o2oa1qn9ku">
      <Reveal className="mx-auto max-w-5xl" data-id="element-94" data-mp="257pm4w32tawu">
        <div className="mb-12 text-center" data-id="element-95" data-mp="256xozgttz54g">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-coral" data-id="element-96" data-mp="2a725v7yni1v7">CO JEST W ŚRODKU</p>
          <h2 className="text-3xl font-black uppercase tracking-tight text-brand-navy md:text-4xl" data-id="element-97" data-mp="2f6ya98b9fvba">
            Co znajdziesz w pakiecie Gotowi na Siatkówkę?
          </h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-98" data-mp="2nz0c9b0z9jno">
          {kitContents.map(({
          icon: ContentIcon,
          title,
          description
        }) => <article key={title} className="rounded-2xl border border-brand-dark bg-brand-main p-7 text-center" data-id="element-99" data-mp="2sxblpknd1s5d">
              <ContentIcon className="mx-auto h-8 w-8 text-brand-navy" strokeWidth={1.5} aria-hidden="true" data-id="element-100" data-mp="2xyr5l9dsxsm6" />
              <h3 className="mt-5 text-xl font-black uppercase tracking-tight text-brand-navy" data-id="element-101" data-mp="32twnlx432n4z">{title}</h3>
              <p className="mt-2 text-sm text-brand-gray" data-id="element-102" data-mp="10j9k86h7fkwy">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}